import { t } from "../../../../../utils/i18n";
import React from "react";

const Body = ({ loads, cardId }) => {
  return (
    <tbody className="table-body">
      {loads.map((load, i) => (
        <tr key={load.id}>
          <td>
            <div className="d-flex justify-content-between">
              <span className="show-from-tab font-weight-bold">{t("cards.common.date_colon")}</span>
              <span className="text-muted">{new Date(load.created_at).getFullYear()}-{(new Date(load.created_at).getMonth() + 1).toString().padStart(2, '0')}-{new Date(load.created_at).getDate().toString().padStart(2, '0')}</span>
            </div>
          </td>
          <td>
            <div className="d-flex justify-content-between">
              <span className="show-from-tab font-weight-bold">{t("cards.common.amount_colon")}</span>
              <span className="text-muted">{load.amount}</span>
            </div>
          </td>
          <td>
            <div className="d-flex justify-content-between">
              <span className="show-from-tab font-weight-bold">{t("cards.common.status_colon")}</span>
              <span className="text-muted">{load.status}</span>
            </div>
          </td>
          <td className="">
            <div className="d-flex justify-content-between">
              <span className="show-from-tab font-weight-bold">{t("cards.loads.loaded_at_colon")}</span>
              <span className="text-muted">{load.formatted_loaded_at}</span>
            </div>
          </td>
          <td>
            <a
              className="btn btn-sm btn-purple w-100"
              href={`/cards/${cardId}/card_loads/${load.id}`}
            >
              {t("cards.common.view")} <i className="fa fa-long-arrow-right"></i>
            </a>
          </td>
        </tr>
      ))}
      {loads.length === 0 && (
        <tr>
          <td colSpan={8} className="text-center">
            {t("cards.loads.empty")}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default Body;
